
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { Fragment, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { DOMAIN } from '../../config';
import SearchID from '../appDialog/searchID';
import SearchRecommand from '../appDialog/searchRecommand';

export default function RightRecommend ({matches}){
   const [recommand,setRecommand] = useState(null)
   const [openSearch, setOpenSearch] = useState(false)
   const [chipTitle, setChipTitle] = useState(null)

    useEffect(()=>{
        fetch(`${DOMAIN}ywyminiappbot/getVideoRecommand`)
            .then((response)=>response.json())
            .then((data)=>{
              if(data.length == 0) return
              setRecommand(data)
          })
      },[])

      const handleOpenSearch = (caption)=>{
        setChipTitle(caption)
        setOpenSearch(true)
      }

    return(
        <Box>
            <SearchRecommand
                openSearch={openSearch} 
                setOpenSearch={setOpenSearch} 
                matches={matches}
                chipTitle={chipTitle}
            />
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                {recommand && recommand.map((item)=>(
                    <ListItem alignItems="flex-start" 
                      onClick={()=>{
                        handleOpenSearch(item.id)
                      }}>
                        <ListItemAvatar>
                        <Avatar
                            sx={{ width: 45, height: 45 }}
                            alt="Travis Howard" src={`${DOMAIN}miniapp/${item.medias[1].fileid}.tb.jpg?fit=crop&auto=format&dpr=2 2x`} />
                        </ListItemAvatar>
                        <ListItemText
                        primary={item.title+"系列"}
                        secondary={
                            <Fragment>
                            <Typography
                                component="span"
                                variant="body2"
                                sx={{ color: 'text.primary', display: 'inline' }}
                            >
                                
                            </Typography>
                                {item.caption.slice(0, 25)+"..."}
                            </Fragment>
                        }
                        />
                    </ListItem>
                ))}
                <Divider variant="inset" component="li" />
                <Box height={50}></Box>
            </List>
        </Box>
    )
}